import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e2f38c6")

_pushScopeId("data-v-6e2f38c6")
const _hoisted_1 = { class: "toc_ui__reminder_main" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"toc_ui__reminder_body\" data-v-6e2f38c6><div class=\"toc_ui__reminder_title\" data-v-6e2f38c6> 温馨提示 </div><div class=\"toc_ui__reminder_cnt\" data-v-6e2f38c6><span data-v-6e2f38c6>1.除事故检测、泡水检测、火烧检测、发动机、变速箱外，其余检测项目结果仅反应检测当下的车辆状况，报告信息仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-6e2f38c6><span data-v-6e2f38c6>2.车辆基本照片仅供参考，实际车辆状况以售卖车辆为准；</span><br data-v-6e2f38c6><span data-v-6e2f38c6>3.对指定车辆进行不解体静态检测，即车辆处于原地静止状态检测，仅限原地着车检测，不包含车辆动态行驶性能检测；</span><br data-v-6e2f38c6><span data-v-6e2f38c6>4.根据检测需要仅对车辆辅件、内饰进行拆解，不对车辆加强件、结构件、发动机、变速器做深度拆解；</span><br data-v-6e2f38c6><span data-v-6e2f38c6>5.90天收购保障，须具备268V检测保障承诺书，单独出具此检测评估报告不具备法律效力；</span><br data-v-6e2f38c6><span data-v-6e2f38c6>6.268V检测标准符合国家二手车鉴定标准和CADA团体标准，且本公司获ISO 9001质量管理体系认证，如对检测标准有异议，或您需要对检测报告进行解读，请拨打400-808-3718咨询。</span></div></div>", 1)
const _hoisted_3 = {
  key: 0,
  class: "toc_ui__anti_body"
}
const _hoisted_4 = { class: "toc_ui__anti_farkurl" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__anti_farklogo" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "toc_ui__anti_farktext" }, "识别二维码查看报告真伪", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.state.antiFakeUrl)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("img", {
              src: _ctx.state.antiFakeUrl
            }, null, 8, ["src"]),
            _hoisted_5
          ]),
          _hoisted_6
        ]))
      : _createCommentVNode("", true)
  ]))
})